import { NoddiColorPicker } from '@ui-components/Inputs/NoddiColorPicker/NoddiColorPicker';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props = {
  label?: string;
  tooltip?: string;
  /** Lets the user remove the color; the field becomes `null`. */
  clearable?: boolean;
};

export const TanstackFormColorPicker = ({ label, tooltip, clearable }: Props) => {
  const field = useFieldContext<string | null>();
  const fieldAria = useTanstackFieldAria(field);

  return (
    <div>
      <NoddiColorPicker
        id={field.name}
        label={label}
        tooltip={tooltip}
        value={field.state.value || null}
        onChange={(value) => field.handleChange(value)}
        onClear={clearable ? () => field.handleChange(null) : undefined}
        {...fieldAria}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
